import React from 'react'
import {ButtonBackToHome} from '../components/ButtonBackToHome'

import '../App.css'

export const NotFound = () => (
    <div>
        <h1 className="title">404 Error!</h1>
        <h2 className="subtitle">Page dosn't exist!</h2>
        <ButtonBackToHome />
    </div>
    
)

